(() => {
	if (window.__JSFFigsStructureInitialized) return;
	window.__JSFFigsStructureInitialized = true;

	document.documentElement.classList.add("jsf-motion-ready");

	const revealObserver = "IntersectionObserver" in window
		? new IntersectionObserver((entries, observer) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;
				entry.target.classList.add("is-revealed");
				observer.unobserve(entry.target);
			});
		}, { rootMargin: "0px 0px -7% 0px", threshold: 0.08 })
		: null;

	const updateRailButtons = (shell) => {
		const rail = shell.querySelector("[data-jsf-figs-rail]");
		const previous = shell.querySelector("[data-jsf-rail-prev]");
		const next = shell.querySelector("[data-jsf-rail-next]");
		if (!rail) return;
		const max = Math.max(0, rail.scrollWidth - rail.clientWidth - 2);
		const offset = Math.max(0, Number(shell.dataset.jsfRailOffset || 0));
		if (previous) previous.disabled = offset <= 2;
		if (next) next.disabled = offset >= max;
	};

	const moveRail = (shell, direction) => {
		const rail = shell?.querySelector("[data-jsf-figs-rail]");
		if (!rail) return;
		const firstCard = rail.firstElementChild;
		const styles = window.getComputedStyle(rail);
		const gap = parseFloat(styles.columnGap || styles.gap || 0);
		const step = firstCard
			? Math.max(firstCard.getBoundingClientRect().width + gap, rail.clientWidth * 0.72)
			: rail.clientWidth * 0.8;
		const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
		const currentOffset = Math.max(0, Number(shell.dataset.jsfRailOffset || 0));
		const target = Math.max(0, Math.min(max, currentOffset + direction * step));
		const sectionId = shell.closest('[id^="shopify-section-"]')?.id;
		const applyTarget = () => {
			const currentShell = sectionId
				? document.getElementById(sectionId)?.querySelector("[data-jsf-rail-shell]")
				: shell;
			const currentRail = currentShell?.querySelector("[data-jsf-figs-rail]");
			if (!currentShell || !currentRail) return;
			currentShell.dataset.jsfLastRailTarget = String(Math.round(target));
			currentShell.dataset.jsfRailOffset = String(target);
			currentRail.style.transform = `translate3d(${-target}px, 0, 0)`;
			updateRailButtons(currentShell);
		};
		shell.dataset.jsfLastRailTarget = String(Math.round(target));
		applyTarget();
		window.requestAnimationFrame(applyTarget);
		[60, 180, 420].forEach((delay) => window.setTimeout(applyTarget, delay));
		window.setTimeout(() => {
			const currentShell = sectionId
				? document.getElementById(sectionId)?.querySelector("[data-jsf-rail-shell]")
				: shell;
			if (currentShell) updateRailButtons(currentShell);
		}, 460);
	};

	const bindRail = (shell) => {
		const rail = shell.querySelector("[data-jsf-figs-rail]");
		if (!rail) return;
		shell.dataset.jsfRailBound = "true";
		const offset = Math.max(0, Number(shell.dataset.jsfRailOffset || 0));
		rail.style.transform = `translate3d(${-offset}px, 0, 0)`;
		updateRailButtons(shell);
	};

	const init = (root = document) => {
		root.querySelectorAll("[data-jsf-rail-shell]").forEach(bindRail);
		root.querySelectorAll("[data-jsf-reveal]").forEach((element) => {
			if (element.dataset.jsfRevealBound === "true") return;
			element.dataset.jsfRevealBound = "true";
			if (revealObserver && !window.Shopify?.designMode) {
				revealObserver.observe(element);
			} else {
				element.classList.add("is-revealed");
			}
		});
	};

	document.addEventListener("click", (event) => {
		const railButton = event.target.closest("[data-jsf-rail-prev], [data-jsf-rail-next]");
		if (railButton) {
			event.preventDefault();
			const shell = railButton.closest("[data-jsf-rail-shell]");
			moveRail(shell, railButton.hasAttribute("data-jsf-rail-prev") ? -1 : 1);
			return;
		}

		const backToTop = event.target.closest("[data-jsf-back-to-top]");
		if (backToTop) {
			const section = backToTop.closest("[data-jsf-collection-grid]");
			const top = section ? section.getBoundingClientRect().top + window.scrollY : 0;
			window.scrollTo({ top, behavior: "smooth" });
			return;
		}

		const filterSummary = event.target.closest("[data-jsf-filter] > summary");
		if (filterSummary) {
			const current = filterSummary.parentElement;
			current.closest("[data-jsf-collection-grid]")
				?.querySelectorAll("[data-jsf-filter][open]")
				.forEach((other) => {
					if (other !== current) other.removeAttribute("open");
				});
			return;
		}

		if (event.target.closest("[data-jsf-filter]")) return;
		document.querySelectorAll("[data-jsf-filter][open]").forEach((details) => details.removeAttribute("open"));
	}, true);

	document.addEventListener("change", (event) => {
		const sort = event.target.closest("[data-jsf-sort]");
		if (sort?.form) sort.form.submit();
	});

	document.addEventListener("scroll", (event) => {
		const rail = event.target.closest?.("[data-jsf-figs-rail]");
		if (rail) {
			const shell = rail.closest("[data-jsf-rail-shell]");
			if (shell) window.requestAnimationFrame(() => updateRailButtons(shell));
		}
	}, true);

	const refreshBackToTop = () => {
		document.querySelectorAll("[data-jsf-back-to-top]").forEach((button) => {
			const section = button.closest("[data-jsf-collection-grid]");
			if (!section) return;
			const rect = section.getBoundingClientRect();
			button.classList.toggle("is-visible", rect.top < -window.innerHeight * 0.65 && rect.bottom > 120);
		});
	};

	window.addEventListener("scroll", () => window.requestAnimationFrame(refreshBackToTop), { passive: true });
	window.addEventListener("resize", () => {
		document.querySelectorAll("[data-jsf-rail-shell]").forEach(updateRailButtons);
		refreshBackToTop();
	}, { passive: true });

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", () => {
			init();
			refreshBackToTop();
		});
	} else {
		init();
		refreshBackToTop();
	}

	document.addEventListener("shopify:section:load", (event) => init(event.target));

	if ("MutationObserver" in window) {
		const mutationObserver = new MutationObserver((mutations) => {
			for (const mutation of mutations) {
				for (const node of mutation.addedNodes) {
					if (node.nodeType === 1) init(node);
				}
			}
		});
		mutationObserver.observe(document.documentElement, { childList: true, subtree: true });
	}
})();
